import { createPortal } from 'react-dom';

var NumPadWr = function (_a) {
    var containerRef = _a.containerRef, children = _a.children;
    if (containerRef) {
        return createPortal(children, containerRef);
    }
    return null;
};

export { NumPadWr };
